import React from 'react';
import { motion } from 'framer-motion';
import { ShieldAlert, Lock, Activity, Cpu } from 'lucide-react';
const solutions = [{
  id: '01',
  name: 'Bastion Shield',
  icon: <ShieldAlert className="w-8 h-8 text-brand-steel" data-id="element-182" />,
  description: 'Endpoint hardening & zero-trust enforcement.',
  features: ['Micro-segmentation of critical assets', 'Continuous identity verification', 'Automated device quarantine protocols']
}, {
  id: '02',
  name: 'Cipher Veil',
  icon: <Lock className="w-8 h-8 text-brand-cyan" data-id="element-183" />,
  description: 'End-to-end data encryption suite.',
  features: ['Quantum-resistant cryptographic algorithms', 'Data-in-transit and at-rest protection', 'Decentralized key management']
}, {
  id: '03',
  name: 'Sentinel Mesh',
  icon: <Activity className="w-8 h-8 text-brand-steel" data-id="element-184" />,
  description: 'Real-time network traffic analysis & anomaly detection.',
  features: ['Deep packet inspection at wire speed', 'Behavioral baseline monitoring', 'Lateral movement detection']
}, {
  id: '04',
  name: 'Aegis Pulse',
  icon: <Cpu className="w-8 h-8 text-brand-cyan" data-id="element-185" />,
  description: 'AI-driven threat intelligence & incident response.',
  features: ['Predictive threat modeling', 'Automated playbook execution', 'Global threat feed integration']
}];
export function SolutionsSection() {
  return <section id="solutions" className="py-24 bg-brand-darker relative border-y border-brand-border" data-id="element-186">
      <div className="container mx-auto px-6" data-id="element-187">
        <div className="text-center mb-20" data-id="element-188">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="inline-block mb-4" data-id="element-189">
            <span className="font-mono text-sm text-brand-cyan tracking-widest uppercase border border-brand-cyan/30 bg-brand-cyan/10 px-4 py-1.5 rounded-full" data-id="element-190">
              Proprietary Tech
            </span>
          </motion.div>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-5xl font-mono font-bold text-white mb-6" data-id="element-191">
            Our Arsenal
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-slate-400 text-lg max-w-2xl mx-auto" data-id="element-192">
            We don't rely on off-the-shelf tools. Epicdrop deploys proprietary,
            military-grade systems designed to actively hunt and neutralize
            threats.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-193">
          {solutions.map((solution, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-brand-dark border border-brand-border rounded-lg p-6 hover:shadow-[0_0_30px_rgba(74,144,217,0.1)] transition-all group" data-id="element-194">
              <div className="flex justify-between items-start mb-8" data-id="element-195">
                <div className="p-3 bg-brand-darker rounded-lg border border-brand-border group-hover:border-brand-steel transition-colors" data-id="element-196">
                  {solution.icon}
                </div>
                <span className="font-mono text-2xl font-bold text-brand-border group-hover:text-brand-steel/30 transition-colors" data-id="element-197">
                  {solution.id}
                </span>
              </div>

              <h3 className="text-xl font-mono font-bold text-white mb-2" data-id="element-198">
                {solution.name}
              </h3>
              <p className="text-sm text-slate-400 mb-6 h-10" data-id="element-199">
                {solution.description}
              </p>

              <ul className="space-y-3" data-id="element-200">
                {solution.features.map((feature, fIndex) => <li key={fIndex} className="flex items-start gap-2 text-sm text-slate-300" data-id="element-201">
                    <span className="text-brand-steel mt-0.5" data-id="element-202">▹</span>
                    {feature}
                  </li>)}
              </ul>
            </motion.div>)}
        </div>
      </div>
    </section>;
}